<template lang="pug">
div(
    :class="styles.root"
)
    div(
        :class="[styles.logo, styles['skeleton-logo']]"
    )
    div(
        :class="styles['skeleton-text']"
    )
        div(
            :class="styles.skeleton"
            :style="{ width }"
        )
</template>

<script lang="ts">
import Vue, { ref, useCssModule } from 'vue'

export default Vue.extend({
    name: 'BankCellSkeleton',
    setup() {
        const styles = useCssModule()
        const width = ref('')

        function setWidth() {
            const widthRange = [0.3, 0.7]
            const random = parseFloat(
                (
                    Math.abs(widthRange[1] - widthRange[0]) *
                    Math.random() *
                    100
                ).toFixed(2)
            )
            const maxWidth =
                (widthRange[0] >= widthRange[1]
                    ? widthRange[0]
                    : widthRange[1]) * 100
            width.value = `${((maxWidth - random) * 100) / 100}%`
        }

        setWidth()

        return {
            styles,
            width,
        }
    },
})
</script>

<style module lang="scss" src="./BankCell.module.scss" />
